import { useContext } from "react";
import { InvitedUsersContex } from "../context/InvitedUsersContext";

const useInvitedUsers = () => {
  const arg = useContext(InvitedUsersContex);
  return { ...arg };
};

export default useInvitedUsers;
